// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="march-10-2020">March 10, 2020</h3>
      <p>Launch of the Loan Guaranty API</p>
    </div>
  );
};

export default MarkdownComponent;
